export class JavaCompilerStringConstants {
    public static mainMethodIdentifier = "$main";
    public static fullspeedAnnotationIdentifier = "Fullspeed";
}